import React, {useEffect, useRef, useState} from 'react'
import {useFormik} from 'formik'
import {TextInput} from '../../../../../components/inputs/TextInput'
import {ModeleClient} from '../../../../../components/Models'
import {SelectInput} from '../../../../../components/inputs/SelectInput'
import {pays} from '../../../../../components/Data'
import {useNavigate} from 'react-router-dom'
import {
  checkClientDuplicate,
  getCompanyBySiret,
  getLastClientId,
} from '../../../../../components/requests'
import {toast} from 'react-toastify'
import Swal from 'sweetalert2'
import * as Yup from 'yup'

const phoneRegex = /^(?:\+33|33|0)[\s.-]*[1-9](?:[\s.-]?\d{2}){4}$/
let clientSchemaSociety = Yup.object()
  .shape({
    professionnel: Yup.string().default('1'),
    nomSociete: Yup.string().required('Le nom de la société est requis'),
    codeClientAAuto: Yup.string().notRequired(),
    codeClientAMoto: Yup.string().notRequired(),
    codeClientAIndus: Yup.string().notRequired(),
    siren: Yup.string().notRequired(),
    codeNaf: Yup.string().notRequired(),
    libelleCodeNaf: Yup.string().notRequired(),
    telephone: Yup.string()
      .nullable()
      .matches(phoneRegex, 'Format du numéro de téléphone invalide'),
    mobile: Yup.string().nullable().matches(phoneRegex, 'Format du mobile invalide'),
    email: Yup.string().nullable().email("L'adresse mail n'est pas valide"),
    siteWeb: Yup.string().notRequired(),
  })
  .test(
    'at-least-one-contact',
    'Au moins un des champs « téléphone », « mobile » ou « e-mail ».',
    function (value) {
      const {telephone, mobile, email} = value
      if (telephone || mobile || email) {
        return true
      }
      return this.createError({
        path: 'contactGroupError',
        message: 'Au moins un des champs « téléphone », « mobile » ou « e-mail ».',
      })
    }
  )
let clientSchemaParticular = Yup.object()
  .shape({
    professionnel: Yup.string().default('1'),
    nom: Yup.string().required('Le nom est requis'),
    prenom: Yup.string().required('Le prénom est requis'),
    codeClientAAuto: Yup.string().notRequired(),
    codeClientAMoto: Yup.string().notRequired(),
    codeClientAIndus: Yup.string().notRequired(),
    adresse: Yup.string().notRequired(),
    complementAdresse: Yup.string().notRequired(),
    codePostal: Yup.string().notRequired(),
    ville: Yup.string().notRequired(),
    siteWeb: Yup.string().notRequired(),
    telephone: Yup.string()
      .nullable()
      .matches(phoneRegex, 'Format du numéro de téléphone invalide'),
    mobile: Yup.string().nullable().matches(phoneRegex, 'Format du mobile invalide'),
    email: Yup.string().nullable().email("L'adresse mail n'est pas valide"),
  })
  .test(
    'at-least-one-contact',
    'Au moins un des champs « téléphone », « mobile » ou « e-mail ».',
    function (value) {
      const {telephone, mobile, email} = value
      if (telephone || mobile || email) {
        return true
      }
      return this.createError({
        path: 'contactGroupError',
        message: 'Au moins un des champs « téléphone », « mobile » ou « e-mail ».',
      })
    }
  )

const ClientForm = (props) => {
  //initilisation model client proprieté api
  let initialData = {}
  const size = Object.keys(props.data).length
  if (size > 2) {
    initialData = props.data
  } else {
    const obj: ModeleClient = {
      siren: '',
      nomSociete: '',
      codeClientAAuto: '',
      codeClientAIndus: '',
      codeClientAMoto: '',
      nom: '',
      prenom: '',
      adresse: '',
      complementAdresse: '',
      codePostal: '',
      ville: '',
      telephone: '',
      mobile: '',
      email: '',
      siteWeb: '',
      codeNaf: '',
      libelleCodeNaf: '',
      receptionCommande: true,
    }
    initialData = {...props.data, ...obj}
  }

  const navigate = useNavigate()
  const [clientId, setClientId] = useState(props.clientId)
  const [data, setData] = useState<ModeleClient>(initialData)
  const [loading, setLoading] = useState(false)
  const [loadingSiret, setLoadingSiret] = useState(false)
  const [professional, setProfessional] = useState(props.data?.professionnel)
  const [useModal, setUseModal] = useState(false)
  const modalCreateCliRef = useRef<HTMLSpanElement | null>(null)
  const [modalExists, setModalExists] = useState(false)
  const [isProspect, setIsProspect] = useState(props?.convertClient ? false : props.data?.prospect)
  const [isProspectPro, setIsProspectPro] = useState(false)

  const [isErrorCodeNaf, setIsErrorCodeNaf] = useState('')
  const [isErrorSiren, setIsErrorSiren] = useState('')
  const [isErrorNom, setIsErrorNom] = useState('')
  const [isErrorPrenom, setIsErrorPrenom] = useState('')
  const [isErrorLibelleCodeNaf, setIsErrorLibelleCodeNaf] = useState('')
  const [isErrorAdresse, setIsErrorAdresse] = useState('')
  const [isErrorCodePostal, setIsErrorCodePostal] = useState('')
  const [isErrorVille, setIsErrorVille] = useState('')
  const [codeClientKoena, setCodeClientKoena] = useState<string>('')

  const getClientId = () => {
    if (props?.codeClientKoena !== null && props?.codeClientKoena !== undefined) {
      setCodeClientKoena(props?.codeClientKoena)
    } else {
      getLastClientId()
        .then((response) => {
          if (response?.status === 200 && response?.data !== undefined) {
            setCodeClientKoena(response?.data + 1)
          }
        })
        .catch((e) => {
          console.log('Erreur')
        })
    }
  }

  const validateSiret = (value, isRequired = true) => {
    const cleaned = value.replace(/\s+/g, '')
    if (isRequired && cleaned === '') {
      setIsErrorSiren('Le siret est requis')
      return false
    } else {
      setIsErrorSiren('')
    }
    if (!/^\d*$/.test(cleaned)) {
      setIsErrorSiren('Le SIRET doit contenir uniquement des chiffres')
      return false
    } else {
      setIsErrorSiren('')
    }
    if (cleaned.length !== 14) {
      setIsErrorSiren('Le SIRET doit contenir exactement 14 chiffres')
      return false
    } else {
      setIsErrorSiren('')
    }
    return true
  }

  const formik = useFormik<ModeleClient>({
    initialValues: data,
    validationSchema: () =>
      Yup.lazy(() => {
        if (professional) return clientSchemaSociety
        else return clientSchemaParticular
      }),
    onSubmit: async (values) => {
      setLoading(true)
      const fieldsUp = checkRequiredFields(values, professional, false)
      let updatedData = {...data, ...values}
      let isClient = true
      if (!fieldsUp) {
        isClient = false
        updatedData = {...updatedData, prospect: true}
      } else {
        updatedData = {...updatedData, prospect: false}
      }
      try {
        // Vérifie les doublons
        const {emailExists, telephoneExists} = await checkClientDuplicate({
          id: updatedData.id,
          email: updatedData.email,
          telephone: updatedData.telephone,
        })
        //affichage de confirmation
        const askConfirmation = async (title, text) => {
          const result = await Swal.fire({
            title,
            text,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Oui, continuer',
            cancelButtonText: 'Annuler',
            confirmButtonColor: '#1BC5BD',
            cancelButtonColor: '#F64E60',
            width: '500px',
          })
          // Affichage des messages d'alerte pour les champs requis après le clic sur annuler du modal conversion en prospect
          if (result.isDismissed && title === 'Créer ce contact en Prospect ?') {
            checkRequiredFields(values, professional, true)
          }
          return result.isConfirmed
        }
        // Gère les cas de doublons
        let message = ''
        if (emailExists && telephoneExists) {
          message =
            'Le mail et le numéro de téléphone saisis sont déjà utilisés par un autre client. Voulez-vous continuer ?'
        } else if (emailExists) {
          message = 'Le mail saisi est déjà utilisé par un autre client. Voulez-vous continuer ?'
        } else if (telephoneExists) {
          message =
            'Le numéro du téléphone saisi est déjà utilisé par un autre client. Voulez-vous continuer ?'
        }

        if (message && !(await askConfirmation('Oups', message))) {
          setLoading(false)
          return
        }
        // Vérifie s'il est client ou prospect
        if (!isClient) {
          const msg =
            'Les informations saisies sont incomplètes pour créer un client confirmé. Ce contact sera créé en statut PROSPECT. Vous pourrez compléter plus tard ses informations pour le passer en Client. Voulez-vous continuer ?'
          if (!(await askConfirmation('Créer ce contact en Prospect ?', msg))) {
            setLoading(false)
            return
          }
        }
        // Soumission du formulaire
        props.submitForm(updatedData, (response) => {
          formik.resetForm()
          setLoading(false)
        })
      } catch (error) {
        console.error(error)
        setLoading(false)
      }
    },
  })

  const validationRules = {
    codeNaf: {
      required: 'Le code naf est requis',
      setError: setIsErrorCodeNaf,
    },
    libelleCodeNaf: {
      required: 'Le libelle code naf est requis',
      setError: setIsErrorLibelleCodeNaf,
    },
    nom: {
      required: 'Le nom est requis',
      setError: setIsErrorNom,
    },
    prenom: {
      required: 'Le prénom est requis',
      setError: setIsErrorPrenom,
    },
    adresse: {
      required: '',
      setError: setIsErrorAdresse,
    },
    codePostal: {
      required: 'Le code postal est requis',
      setError: setIsErrorCodePostal,
    },
    ville: {
      required: 'La ville est requise',
      setError: setIsErrorVille,
    },
  }

  const onKeyUpFields = (value, libelle) => {
    const rule = validationRules[libelle]
    if (!rule) return true
    const {required, setError} = rule
    if (required && value === '') {
      setError(required)
      return
    }
    setError('')
    return
  }

  const checkRequiredFields = (value, professional, showMessage: boolean = true) => {
    let isValid = true

    // Liste des champs avec leurs messages d'erreur et setters
    const fields = [
      {key: 'nom', message: showMessage ? 'Le nom est requis' : '', setter: setIsErrorNom},
      {key: 'prenom', message: showMessage ? 'Le prénom est requis' : '', setter: setIsErrorPrenom},
      {
        key: 'adresse',
        message: showMessage ? "L'adresse est requise" : '',
        setter: setIsErrorAdresse,
      },
      {
        key: 'codePostal',
        message: showMessage ? 'Le code postal est requis' : '',
        setter: setIsErrorCodePostal,
      },
      {key: 'ville', message: showMessage ? 'La ville est requise' : '', setter: setIsErrorVille},
    ]

    // Champs spécifiques au mode professionnel
    const professionalFields = [
      {key: 'codeNaf', message: 'Le code naf est requis', setter: setIsErrorCodeNaf},
      {key: 'siren', message: 'Le siret est requis', setter: setIsErrorSiren},
      {
        key: 'libelleCodeNaf',
        message: 'Le libelle code naf est requis',
        setter: setIsErrorLibelleCodeNaf,
      },
    ]

    // Fusion des champs si mode professionnel
    const allFields = professional ? [...fields, ...professionalFields] : fields

    // Vérification
    for (const field of allFields) {
      if (!value[field.key]) {
        if (showMessage) {
          field.setter(field.message)
        } else {
          field.setter('')
        }
        isValid = false
      }
    }

    return isValid
  }

  // déclenchement du modal de recherche de véhicule après la création du client
  useEffect(() => {
    if (props.openModalResVeh) {
      modalCreateCliRef.current?.click()
    }
  }, [props?.openModalResVeh])

  // Pour supprimer les messages d'alertes lors des switchs entre Particulier - Professionnel
  useEffect(() => {
    checkRequiredFields(
      ['nom', 'prenom', 'adresse', 'codePostal', 'ville', 'codeNaf', 'siren'],
      true,
      false
    )
  }, [formik.values.professionnel])

  useEffect(() => {
    //Recalcule les erreurs avec le nouveau validationSchema,
    //Supprime les erreurs qui ne sont plus valides.
    formik.validateForm()
  }, [professional])

  const isProfessionel = (value) => {
    if (value === false || value === true) {
      return value
    }
    return Boolean(parseInt(value.toString()))
  }

  // evènemment search siret
  const searchCustomerBySiren = async () => {
    const siren = formik.values.siren
    try {
      if (!siren || !validateSiret(siren)) return false
      setLoadingSiret(true)
      try {
        const data = await getCompanyBySiret(siren)
        if (data) {
          const dataSiret = {
            siren: siren,
            nom: data[0]['nom'] ?? props.data.nom,
            prenom: data[0]['prenom'] ?? props.data.prenom,
            nomSociete: data[0]['nomSociete'],
            adresse: data[0]['adresse'],
            complementAdresse: data[0]['complementAdresse'],
            codePostal: data[0]['codePostal'],
            ville: data[0]['ville'],
            pays: data[0]['pays'],
            codeNaf: data[0]['codeNaf'],
            libelleCodeNaf: data[0]['libelleCodeNaf'],
            professionnel: true,
            idPays: data[0]['idPays'],
            telephone: formik.values.telephone,
            mobile: formik.values.mobile,
            email: formik.values.email,
            siteWeb: formik.values.siteWeb,
            prospect: formik.values.prospect,
            codeClientAAuto: formik.values.codeClientAAuto,
            codeClientAIndus: formik.values.codeClientAIndus,
            codeClientAMoto: formik.values.codeClientAMoto,
          }
          formik.setValues(dataSiret)

          //appel de la fonction qui verifie les champs requis
          if (dataSiret.codeNaf) {
            onKeyUpFields(dataSiret.codeNaf, 'codeNaf')
          }
          if (dataSiret.libelleCodeNaf) {
            onKeyUpFields(dataSiret.libelleCodeNaf, 'libelleCodeNaf')
          }
          if (dataSiret.nom) {
            onKeyUpFields(dataSiret.nom, 'nom')
          }
          if (dataSiret.prenom) {
            onKeyUpFields(dataSiret.prenom, 'prenom')
          }
          if (dataSiret.nomSociete) {
            onKeyUpFields(dataSiret.nomSociete, 'nomSociete')
          }
          if (dataSiret.adresse) {
            onKeyUpFields(dataSiret.adresse, 'adresse')
          }
          if (dataSiret.codePostal) {
            onKeyUpFields(dataSiret.codePostal, 'codePostal')
          }
          if (dataSiret.ville) {
            onKeyUpFields(dataSiret.ville, 'ville')
          }

          setLoadingSiret(false)
        } else {
          formik.setValues(initialData)
          console.log('Aucune donnée trouvée pour ce SIRET.')
        }
      } catch (error) {
        props.data.siren && formik.setFieldValue('siren', props.data.siren)
        toast.error("Le siret n'est pas valide", {autoClose: 4000})
        console.error('Erreur lors de la récupération des données :', error)
        setLoadingSiret(false)
      }
    } catch (errSiret) {}
  }

  useEffect(() => {
    if (!clientId) {
      formik.setFieldValue('idPays', 75)
    }
    // Vérifie si une modal avec l'ID "clientCreatedModal" est présente dans le DOM
    const modal = document.getElementById('ModalClientCreate')
    setModalExists(!!modal)
    setUseModal(props?.isCreateViaModal ?? false)
    // Affiche immédiatement les erreurs de validation lors de la conversion d’un prospect en client
    if (props.convertClient) {
      const touchedFields = {}
      Object.keys(formik.values).forEach((field) => {
        touchedFields[field] = true
      })
      formik.setTouched(touchedFields)
      formik.validateForm()
    }
    // Affiche immédiatement les erreurs de validation lors de la conversion d’un prospect en client

    getClientId()
  }, [])

  // pour déterminer si c'est lors de la création de demande ou pas
  useEffect(() => {
    setUseModal(props?.isCreateViaModal ?? false)
  }, [props])

  const handleSiretChange = (e) => {
    const rawValue = e.target.value
    validateSiret(rawValue)
    // Supprimer tous les espaces
    const normalizedValue = rawValue.replace(/\s+/g, '')
    formik.setFieldValue('siren', normalizedValue)
  }

  return (
    <div>
      <form onSubmit={formik.handleSubmit} noValidate className='form'>
        <div className='card-body border-top p-9'>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>Type de client</label>

            <div className='col-lg-8 fv-row'>
              <div className='d-flex align-items-center mt-3'>
                <label className='form-check form-check-inline form-check-solid me-5'>
                  <input
                    className='form-check-input'
                    type='radio'
                    value={0}
                    name={'professionnel'}
                    onChange={formik.handleChange}
                    defaultChecked={!formik.values.professionnel}
                    onClick={() => {
                      setProfessional(false)
                    }}
                  />
                  <span className='fw-bold ps-2 fs-6'>Particulier</span>
                </label>

                <label className='form-check form-check-inline form-check-solid'>
                  <input
                    className='form-check-input'
                    type='radio'
                    value={1}
                    name={'professionnel'}
                    onChange={formik.handleChange}
                    defaultChecked={formik.values.professionnel}
                    onClick={() => {
                      setProfessional(true)
                    }}
                  />
                  <span className='fw-bold ps-2 fs-6'>Société</span>
                </label>
              </div>
            </div>
          </div>

          <div
            className='row mb-6'
            style={!isProfessionel(formik.values.professionnel) ? {display: 'none'} : {}}
          >
            <label className={`col-lg-4 col-form-label fw-bold fs-6`}>Siret</label>

            <div className='col-lg-4 fv-row'>
              <TextInput
                fieldName={'siren'}
                inputPlaceholder={'SIRET'}
                inputType={'text'}
                inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                formik={formik}
                onKeyUp={handleSiretChange}
              />
              {isErrorSiren && <p className='text-danger'>{isErrorSiren}</p>}
            </div>
            <div className='col-lg-4 fv-row'>
              <button
                type='button'
                className='btn btn-primary'
                disabled={loadingSiret}
                onClick={() => searchCustomerBySiren()}
              >
                {!loadingSiret && 'Rechercher'}
                {loadingSiret && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Recherche...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </div>

          <div
            className='row mb-6'
            style={!isProfessionel(formik.values.professionnel) ? {display: 'none'} : {}}
          >
            <label className={`col-lg-4 col-form-label fw-bold fs-6`}>Code naf</label>

            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'codeNaf'}
                    inputPlaceholder={'Code naf'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    onKeyUp={(e) => onKeyUpFields(e.target.value, 'codeNaf')}
                    formik={formik}
                  />
                  {isErrorCodeNaf && <p className='text-danger'>{isErrorCodeNaf}</p>}
                </div>

                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'libelleCodeNaf'}
                    inputPlaceholder={'Libelle code naf'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    onKeyUp={(e) => onKeyUpFields(e.target.value, 'libelleCodeNaf')}
                    formik={formik}
                  />
                  {isErrorLibelleCodeNaf && <p className='text-danger'>{isErrorLibelleCodeNaf}</p>}
                </div>
              </div>
            </div>
          </div>

          <div className='row mb-6'>
            <label
              className={`col-lg-4 col-form-label ${
                !isProfessionel(formik.values.professionnel) ? 'required' : ''
              } fw-bold fs-6`}
            >
              Nom complet
            </label>

            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'nom'}
                    inputPlaceholder={'Nom'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    onKeyUp={professional ? (e) => onKeyUpFields(e.target.value, 'nom') : undefined}
                    formik={formik}
                  />
                  {isErrorNom && <p className='text-danger'>{isErrorNom}</p>}
                </div>

                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'prenom'}
                    inputPlaceholder={'Prénom'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    onKeyUp={
                      professional ? (e) => onKeyUpFields(e.target.value, 'prenom') : undefined
                    }
                    formik={formik}
                  />
                  {isErrorPrenom && <p className='text-danger'>{isErrorPrenom}</p>}
                </div>
              </div>
            </div>
          </div>

          <div
            className='row mb-6'
            style={!isProfessionel(formik.values.professionnel) ? {display: 'none'} : {}}
          >
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>
              Nom de la société
            </label>

            <div className='col-lg-8 fv-row'>
              <TextInput
                fieldName={'nomSociete'}
                inputPlaceholder={'Société'}
                inputType={'text'}
                inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                onKeyUp={(e) => onKeyUpFields(e.target.value, 'nomSociete')}
                formik={formik}
              />
            </div>
          </div>

          <div className='row mb-6'>
            <label className={`col-lg-4 col-form-label fw-bold fs-6`}>Adresse principale</label>
            <div className='col-lg-8'>
              <div className='row mb-4'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'adresse'}
                    inputPlaceholder={'Adresse'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    onKeyUp={(e) => onKeyUpFields(e.target.value, 'adresse')}
                    formik={formik}
                  />
                  {isErrorAdresse && <p className='text-danger'>{isErrorAdresse}</p>}
                </div>

                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'complementAdresse'}
                    inputPlaceholder={"Complément d'adresse"}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
              <div className='row mb-4'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'codePostal'}
                    inputPlaceholder={'Code postal'}
                    inputType={'text'}
                    value={'4566666'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    onKeyUp={(e) => onKeyUpFields(e.target.value, 'codePostal')}
                    formik={formik}
                  />
                  {isErrorCodePostal && <p className='text-danger'>{isErrorCodePostal}</p>}
                </div>

                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'ville'}
                    inputPlaceholder={'Ville'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    onKeyUp={(e) => onKeyUpFields(e.target.value, 'ville')}
                    formik={formik}
                  />
                  {isErrorVille && <p className='text-danger'>{isErrorVille}</p>}
                </div>
              </div>
              <div className='row'>
                <div className='col-lg-12 fv-row'>
                  <SelectInput
                    fieldName={'idPays'}
                    inputClassName={'form-select form-select-solid form-select-lg fw-bold'}
                    options={pays}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className='row mb-6'>
            <label className={`col-lg-4 col-form-label fw-bold fs-6`}>Téléphone</label>

            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'telephone'}
                    inputPlaceholder={'Fixe'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>

                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'mobile'}
                    inputPlaceholder={'Mobile'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className='row mb-6'>
            <label className={`col-lg-4 col-form-label fw-bold fs-6`}>Email</label>

            <div className='col-lg-8 fv-row'>
              <TextInput
                fieldName={'email'}
                inputPlaceholder={'Email'}
                inputType={'text'}
                inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                formik={formik}
              />
            </div>
          </div>

          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>Site web</label>

            <div className='col-lg-8 fv-row'>
              <TextInput
                fieldName={'siteWeb'}
                inputPlaceholder={'Site web'}
                inputType={'text'}
                inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                formik={formik}
              />
            </div>
          </div>

          <div className='row mb-6'>
            <label className={`col-lg-4 col-form-label fw-bold fs-6`}>Code client</label>

            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-3 fv-row'>
                  <input
                    type={'text'}
                    className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    placeholder={codeClientKoena === '' ? 'Chargement...' : 'Koena'}
                    value={codeClientKoena}
                    style={{cursor: 'not-allowed'}}
                    disabled={true}
                    readOnly={true}
                  />
                </div>
                <div className='col-lg-3 fv-row'>
                  <TextInput
                    fieldName={'codeClientAAuto'}
                    inputPlaceholder={'Aauto'}
                    inputType={'text'}
                    inputClassName={
                      'form-control form-control-lg form-control-solid mb-3 mb-lg-0 fs-7'
                    }
                    onKeyUp={(e) => onKeyUpFields(e.target.value, 'codeClientAAuto')}
                    formik={formik}
                  />
                </div>
                <div className='col-lg-3 fv-row'>
                  <TextInput
                    fieldName={'codeClientAMoto'}
                    inputPlaceholder={'Amoto'}
                    inputType={'text'}
                    inputClassName={
                      'form-control form-control-lg form-control-solid mb-3 mb-lg-0 fs-7'
                    }
                    onKeyUp={(e) => onKeyUpFields(e.target.value, 'codeClientAMoto')}
                    formik={formik}
                  />
                </div>
                <div className='col-lg-3 fv-row'>
                  <TextInput
                    fieldName={'codeClientAIndus'}
                    inputPlaceholder={'Aindustrie'}
                    inputType={'text'}
                    inputClassName={
                      'form-control form-control-lg form-control-solid mb-3 mb-lg-0 fs-7'
                    }
                    onKeyUp={(e) => onKeyUpFields(e.target.value, 'codeClientAIndus')}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>
              Actif pour la réception de commande
            </label>

            <div className='col-lg-8 fv-row align-self-center'>
              <input
                type={'checkbox'}
                className={'form-check-input'}
                checked={formik.values.receptionCommande}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name='receptionCommande'
                value={formik.values.receptionCommande ? 'true' : 'false'}
              />
            </div>
          </div>

          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>Message</label>

            <div className='col-lg-8 fv-row'>
              <textarea
                name='message'
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder='Écrire un message...'
                value={formik.values.message}
                onChange={formik.handleChange}
              />
            </div>
          </div>

          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>Message bloquant</label>

            <div className='col-lg-8 fv-row align-self-center'>
              <input
                type={'checkbox'}
                className={'form-check-input'}
                checked={formik.values.messageBloquant}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name='messageBloquant'
                value={formik.values.messageBloquant ? 'true' : 'false'}
              />
            </div>
          </div>

          {/*affichage d'erreur de mail ou telephone*/}
          {formik.errors.contactGroupError && (
            <div className='row mb-6'>
              <div className='col-lg-4'></div>
              <div className='col-lg-8 form-error fv-plugins-message-container'>
                <div className='fv-help-block'>{formik.errors.contactGroupError}</div>
              </div>
            </div>
          )}
        </div>
        <div className='card-footer d-flex gap-2 justify-content-end py-6 px-9'>
          {useModal ? (
            <button
              type='button'
              className='btn btn-light me-3'
              disabled={loading}
              data-bs-target='#exampleModalToggle'
              data-bs-toggle='modal'
              onClick={() => formik.resetForm()}
            >
              Annuler
            </button>
          ) : (
            <button
              type='button'
              className='btn btn-light me-3'
              disabled={loading}
              onClick={() => {
                formik.resetForm()
                if (clientId == null) {
                  navigate(`/vente/clients/liste`)
                } else {
                  navigate(`/vente/clients/${clientId}/afficher`)
                }
              }}
            >
              Annuler
            </button>
          )}
          <button type='submit' className='btn btn-primary' disabled={loading}>
            {!loading && 'Enregistrer'}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Enregistrement...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
          {/*bouton invisible pour déclencher le modal choixContactClient après enregistrement de nouveau client*/}
          <button
            type='button'
            className='d-none'
            ref={props?.saveOnClientChangeRef}
            data-bs-toggle='modal'
            data-bs-target='#choixContactModal'
            data-bs-dismiss='modal'
          ></button>

          {useModal && (
            <>
              <span
                ref={modalCreateCliRef}
                data-bs-target='#exampleModalSearchV'
                data-bs-toggle='modal'
              ></span>
              <button className='btn btn-light' data-bs-dismiss='modal' type='button'>
                Fermer
              </button>
            </>
          )}
        </div>
      </form>
    </div>
  )
}

export {ClientForm}
